import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import { Field, reduxForm } from "redux-form";
import * as Yup from "yup";
import { connect } from "react-redux";

import { ROUTESLIST } from "@/static/urls";
import FrontBanner from "@/assets/images/front-banner.svg";

import Image1 from "@/pages/interest/images/contact_us_top_image.png";
import Image2 from "@/pages/interest/images/contact_us_middle_image.png";
import Image3 from "@/pages/interest/images/contact_us_bottom_image.png";

import MeetImg from "@/pages/interest/images/meet_us_icon.png";
import OnboardImg from "@/pages/interest/images/get_onboarded_icon.png";
import EarnImage from "@/pages/interest/images/start_earning_icon.png";

import clearIcon from "../../assets/images/home/clearIcon.svg";
import assessIcon from "../../assets/images/home/assessIcon.svg";
import licensesIcon from "../../assets/images/home/licensesIcon.svg";

import SocialSticky from "@/components/social-sticky/index";
import { withAuth0 } from "@auth0/auth0-react";
import { bindActionCreators } from "redux";
import { getToken } from "../../actions/auth";
import FormField from "../../components/forms/form-field";

import "./interest.scss";

class InterestPage extends Component {
  constructor(props) {
    super(props);
    const user = localStorage.getItem("userInfo");
    console.log("**user info**",user);
    this.state = {
      windowWidth: window.innerWidth, // Set initial window width
      claims: "", // Initialize claims
    };
    this.constant = [
      {
        title: "Clear",
        icon: clearIcon,
        src: "https://www.youtube.com/embed/5hqbvLuArkE?si=jF7D0Yvrc9FN0b_P",
        description:
          "Ample Samples™ streamlines sample licensing with expert copyright research, negotiation, and agreement management, ensuring a fast and accurate process for music, TV, or film projects.",
      },
      {
        title: "Assess",
        icon: assessIcon,
        src: "https://www.youtube.com/embed/BDBd79wb_jI?si=SDa109Nx4unhKhtH",
        description:
          "Ample Samples™ identifies song samples, their owners, and clearance costs, providing clear insights to simplify and accelerate the approval process.",
      },
      {
        title: "License",
        icon: licensesIcon,
        // src: "https://www.youtube.com/embed/KyFS0PfRynY?si=ScGX-rzjF6SHjBjS",
        src: "https://www.youtube.com/embed/dtFzvMzz3Vs",
        description:
          "Ample Samples™ handles the entire sync licensing process, from copyright research to securing contracts, providing regular updates to keep you informed while ensuring the best terms for your project.",
      },
    ];
    this.submitForm = this.submitForm.bind(this);
    this.state = {
      claims: "",
      redirectToSubscription: false,
    };
  }

  async submitForm(data) {
    const { name,email,phone,socialmedia,interestForm } = data;
    console.log("formSubmit-name",name);
    console.log("formSubmit-email",email);
    console.log("formSubmit-phone",phone);
    console.log("formSubmit-socialmedia",socialmedia);
    console.log("formSubmit-iptype",interestForm);

    const formData = {
      name: name,
      email: email,
      phone: phone,
      socialmedia: socialmedia,
      ip: "producer"
    };

    fetch('https://script.google.com/macros/s/AKfycbxvPpar5qHjn0gYSB3FkAHF_rFe-q8UtZH0rVGHojBzUHsU2xCWjNUX1Ex1UQVGZroxGw/exec', {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then(data => {
      alert('Form submitted successfully!');
      // form.reset();
    })
    .catch(err => {
      alert('Error submitting form');
      console.error(err);
    });
  }

  componentDidMount() {
    const token = localStorage.getItem("token");
    window.addEventListener("resize", this.handleResize); // Listen for resize events when component mounts
    this.handleResize();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize); // Clean up event listener when component unmounts
    this.setState({
      redirectToSubscription: false,
    });
  }

  handleResize = () => {
    this.setState({
      windowWidth: window.innerWidth, // Update the window width in state
    });
  };

  render() {
    const token = localStorage.getItem("token");
    const { handleSubmit, pristine, submitting } = this.props; //submitLogin 

    const { redirectToSubscription, windowWidth } = this.state;
    const { auth } = this.props;


    const dropdownOptions = [
        { value: 'producer', label: 'Producer' },
        { value: 'composer', label: 'Composer' },
        { value: 'catalog', label: 'Catalog' },
        { value: 'owner', label: 'Owner' },
        { value: 'creator', label: 'Content Creator' },
    ];

    function scrollToInterestForm() {
      window.location.href = 'https://calendly.com/theamplesamples'; // Replace with your target domain
    }

    return (
      <main className="page">
        <div className="content">
            <div className="front-banner">
                <img src="https://ample-samples.s3.us-east-2.amazonaws.com/app/front-banner.svg" alt="front-banner" className="banner-image"/>
                <h3 className="front-header">Turn Your Untapped<br/>Catalog Into <span className="coloredWord">Revenue</span>.</h3>
                <p className="front-paragraph">
                Place your music in front of artists, creators, and media producers<br/>
looking for samples today — and let us handle the licensing.
                </p>
                <button className="btn-width" onClick={() => {scrollToInterestForm()}}>
                  🔗 Arrange a Meeting With Us Today
                </button>
            </div>
        </div>

        <div className="content">
          <div className="review-video">
            <div className="review-video__inner">
              <iframe
                width="478"
                height="850"
                src="https://www.youtube.com/embed/r6jFwhXoXUE"
                title="James Mtume on Technology and Sampling" 
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>

        <div className="content">
          <div className="main-body">
            <h2 className="body-style">We Help You <span className="coloredWord">Get Paid for Your Music</span>.</h2>
          </div>
        </div>

        <div className="content">

          {/*  */}
          <div className="section">

            <div className="text-content">
              
              <h1>Ample Samples™ makes it easy to license your tracks to artists, creators, and media producers.<br/>We handle:</h1>
              
              <div className="service">
                <div className="icon-box"><img src={clearIcon} /></div>
                <div className="service-text">
                  <div className="service-title">Clearance</div>
                  <div className="service-subtitle">We check and verify rights.</div>
                </div>
              </div>

              <div className="service">
                <div className="icon-box"><img src={assessIcon} /></div>
                <div className="service-text">
                  <div className="service-title">Connections</div>
                  <div className="service-subtitle">We match your music with active users.</div>
                </div>
              </div>

              <div className="service">
                <div className="icon-box"><img src={licensesIcon} /></div>
                <div className="service-text">
                  <div className="service-title">Licensing</div>
                  <div className="service-subtitle">We manage deals and send your payouts.</div>
                </div>
              </div>
              
            </div>

            <div className="image-side">
              <img src={Image1} alt="Vinyl records background" />
            </div>
          
          </div>

          <section className="opportunity-section">
              <h2>Why Wait for Opportunity to Knock?</h2>
              <p>
                Most creators wait for their work to be discovered. We flip the script. We help you take control by placing your IP in front of creators actively looking to sample, remix, and license content for music, media, and beyond.
              </p>

              <div className="opportunity-content">
                <div className="image-wrapper">
                  <img src={Image2} alt="Person browsing records"/>
                </div>

                <div className="built-for">
                  <h3>This is built for:</h3>
                  <ul>
                    <li>Music Producers & Composers</li>
                    <li>Content Creators & Filmmakers</li>
                    <li>Rights Holders with Untapped Catalogs</li>
                    <li>Artists, Influencers, and Collectives</li>
                  </ul>
                </div>
              </div>
          </section>

          {/*  */}

          <section className="how-it-works">
            <div className="how-text">
              <h2>How It Works!</h2>
              <span>Simple. Fast. Profitable.</span>

              <div className="step">
                <div className="icon-box-3">
                  <img src={MeetImg} alt="Catalog Icon"/>
                </div>
                <div className="step-text">
                  <h4>Meet With Us</h4>
                  <p>We assess your catalog.</p>
                </div>
              </div>

              <div className="step">
                <div className="icon-box-3">
                  <img src={OnboardImg} alt="Onboarding Icon"/>
                </div>
                <div className="step-text">
                  <h4>Get Onboarded</h4>
                  <p>We upload and index your works.</p>
                </div>
              </div>

              <div className="step">
                <div className="icon-box-3">
                  <img src={EarnImage} alt="Earnings Icon"/>
                </div>
                <div className="step-text">
                  <h4>Start Earning</h4>
                  <p>We handle licensing, you collect royalties.</p>
                </div>
              </div>
            </div>

            <div className="image-side">
              <img src={Image3} alt="Record store visual"/>
            </div>
          </section>

          {/*  */}

        </div>
          
        <div className="content">
          <div className="joinnow-section">
            <h1>Put Your Music to Work.</h1>
            <p>
              Join a growing platform where IP works for you — not the other way around.
            </p>
            <button
              className="btn btn-primary btn-fw btn-width"
              onClick={() => {scrollToInterestForm()}}>
              🔗 Arrange a Meeting With Us Today
            </button>
          </div>
        </div>
       
      </main>
    );
  }
}


const renderSelect = ({ input, options }) => (
    <div>
        <label htmlFor="interestForm">Type of IP</label>
        <select className="interest-form-select" id="interestForm" {...input}>
            {options.map((option) => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </select>
    </div>
);

const validationSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required"),
  // password: Yup.string()
  //   .required("Password is required")
  //   .min(
  //     8,
  //     "Password must contain 8 or more characters with at least one of each: uppercase, lowercase, number, and special"
  //   )
  //   .matches(/[a-z]/, "Password must contain at least 1 lowercase letter")
  //   .matches(/[A-Z]/, "Password must contain at least 1 uppercase letter")
  //   .matches(/[0-9]/, "Password must contain at least 1 number")
  //   .matches(/[\W_]/, "Password must contain at least 1 special character"),
  // remember: Yup.boolean()
  //   .oneOf([true], "You must agree to the terms")
  //   .required("You must agree to the terms"),
});

// Function to validate Redux Form fields using Yup
const validate = (values) => {
  try {
    validationSchema.validateSync(values, { abortEarly: false });
    return {};
  } catch (error) {
    return error.inner.reduce((errors, err) => {
      errors[err.path] = err.message;
      return errors;
    }, {});
  }
};

// Apply redux-form and HOC
const interestFormPage = reduxForm({
  form: "interest-form",
  validate, // Add validation function here
})(InterestPage);

const mapStateToProps = (state) => ({
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getToken,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({ form: "interest-form" })(withAuth0(InterestPage)));
